import * as React from 'react';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';

type ContentMarketingTextContainerType = {
    smallText?: boolean;
    contentMarketing: TImprovedContentMarketing;
};

const TextContainer = ({
    contentMarketing,
    smallText,
}: ContentMarketingTextContainerType) => {
    const title = contentMarketing.title.replace(/\\n/g, '<br/>');
    const cleanTitle = contentMarketing.title.replace(/\\n/g, '');
    return (
        <div>
            {Boolean(contentMarketing.sponsorData.name) && (
                <div className={`text-gray-500 text-14 mb-4`}>
                    <span>{contentMarketing.sponsorData.name}</span>
                </div>
            )}
            <a
                className="link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring"
                href={contentMarketing.href}
                target="_blank"
                title={
                    (contentMarketing.text
                        ? `${contentMarketing.text}. `
                        : '') + cleanTitle
                }
                rel="noreferrer"
            >
                <h2
                    className={`${
                        smallText ? 'h4' : 'h3'
                    } text-left font-normal mb-0 whitespace-pre-wrap text-ellipsis no-underline`}
                    id="title_id"
                >
                    <span aria-hidden="true" className="inset-0 absolute" />
                    {!!contentMarketing.text && (
                        <>
                            <span
                                className={`${
                                    smallText ? 'text-12 md:text-14' : 'text-16'
                                } font-bold mb-0 text-left`}
                                dangerouslySetInnerHTML={{
                                    __html: contentMarketing.text,
                                }}
                            />
                            <br />
                        </>
                    )}
                    <span
                        data-testid={'cm-title'}
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                </h2>
            </a>
        </div>
    );
};

export default TextContainer;
